<template>
    <div>
        <div id="icon-pagination-tiny" style="top: 4.1875rem !important" :class="[tiny ? '' : 'd-none']">
            <div class="bg-gray-50 py-2">
                <div class="container mt-0">
                    <div class="row justify-content-center align-items-center flex-nowrap">
                        <div class="flex-grow-1 w-100">
                            <p class="mb-0">
                                <a class="btn-link hover-white link-step1" role="button" @click="navigationController('previous')" v-if="navigation.index > 0">
                                    <svg class="icon icon-xs ml-2" aria-hidden="true" v-if="navigation.index > 0">
                                        <use xlink:href="/assets/img/icon-sprite.svg#global.previous" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                    <span class="">{{ __("lang.kwl.nav.previous_step") }}</span>
                                </a>
                            </p>
                        </div>

                        <div class="flex-shrink-0 d-none d-md-flex justify-content-center" style="gap: 15px">
                            <div class="text-center" v-if="!tiny">
                                <a class="btn-link">
                                    <svg class="icon icon-md rounded" role="img">
                                        <use xlink:href="" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </a>
                            </div>

                            <div class="text-center">
                                <a class="btn-link" role="button" @click="navigationController('Building')" :class="navigation.sides.Building.classes">
                                    <svg class="icon icon-md rounded" role="img" :class="navigation.sides.Building.iconClasses">
                                        <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.building" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </a>
                            </div>

                            <div class="text-center">
                                <a class="btn-link link-step2" role="button" @click="navigationController('Rooms')" :class="navigation.sides.Rooms.classes">
                                    <svg class="icon icon-md rounded" :class="navigation.sides.Rooms.iconClasses" role="img">
                                        <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.rooms" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </a>
                            </div>

                            <div class="text-center">
                                <a class="btn-link link-step3" role="button" @click="navigationController('AirVolumes')" :class="navigation.sides.AirVolumes.classes">
                                    <svg class="icon icon-md rounded" :class="navigation.sides.AirVolumes.iconClasses" role="img">
                                        <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.airquantities" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </a>
                            </div>

                            <div class="text-center">
                                <a class="btn-link link-step4" role="button" @click="navigationController('Devices')" :class="navigation.sides.Devices.classes">
                                    <svg class="icon icon-md rounded" :class="navigation.sides.Devices.iconClasses" role="img">
                                        <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.device" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </a>
                            </div>

                            <div class="text-center">
                                <a class="btn-link link-step5" role="button" @click="navigationController('Equipments')" :class="navigation.sides.Equipments.classes">
                                    <svg class="icon icon-md rounded" :class="navigation.sides.Equipments.iconClasses" role="img">
                                        <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.airdivision" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </a>
                            </div>

                            <div class="text-center">
                                <a class="btn-link link-step6" role="button" @click="navigationController('Overview')" :class="navigation.sides.Overview.classes">
                                    <svg class="icon icon-md rounded" :class="navigation.sides.Overview.iconClasses" role="img">
                                        <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.result" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <div class="flex-grow-1 w-100">
                            <p class="text-right mb-0">
                                <a v-if="!navigation.nextClasses.includes('disabled')" class="btn-link hover-white next-step link-step2" role="button" @click="navigationController('next')" :class="navigation.nextClasses">
                                    <span class="">{{ __("lang.kwl.nav.next_step") }}</span>
                                    <svg class="icon icon-xs ml-2" aria-hidden="true">
                                        <use xlink:href="/assets/img/icon-sprite.svg#global.next" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Error/Warn -->
            <div>
                <Alert type="tiny"></Alert>
            </div>
            <!-- /Error/Warn -->
        </div>
        <!-- Error/Warn -->
        <div v-show="!tiny">
            <Alert type="normal"></Alert>
        </div>
        <!-- /Error/Warn -->
        <!-- Infobox -->
        <JumbotronContainer></JumbotronContainer>
        <!-- /Infobox -->

        <!-- Navigation -->
        <div class="container mt-2" id="icon-pagination">
            <div class="row">
                <div class="col-12">
                    <div class="container-fluid bg-gray-50 rounded p-4">
                        <div class="row align-items-center justify-content-center">
                            <div class="w-100 flex-shrink-0 d-none d-md-flex justify-content-between my-3 px-lg-10" style="gap: 20px">
                                <div class="text-center">
                                    <a class="btn-link link-step1" role="button" @click="navigationController('Building')" :class="navigation.sides.Building.classes">
                                        <svg class="icon icon-xl rounded" :class="navigation.sides.Building.iconClasses">
                                            <title>{{ __("lang.kwl.nav.building_data") }}</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.building" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </a>
                                </div>

                                <div class="text-center">
                                    <a class="btn-link link-step2" role="button" @click="navigationController('Rooms')" :class="navigation.sides.Rooms.classes">
                                        <svg class="icon icon-xl rounded" :class="navigation.sides.Rooms.iconClasses">
                                            <title>{{ __("lang.kwl.nav.room_data") }}</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.rooms" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </a>
                                </div>

                                <div class="text-center">
                                    <a class="btn-link link-step3" role="button" @click="navigationController('AirVolumes')" :class="navigation.sides.AirVolumes.classes">
                                        <svg class="icon icon-xl rounded" :class="navigation.sides.AirVolumes.iconClasses">
                                            <title>{{ __("lang.kwl.nav.air_volumes") }}</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.airquantities" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </a>
                                </div>

                                <div class="text-center">
                                    <a class="btn-link link-step4" role="button" @click="navigationController('Devices')" :class="navigation.sides.Devices.classes">
                                        <svg class="icon icon-xl rounded" :class="navigation.sides.Devices.iconClasses">
                                            <title>{{ __("lang.kwl.nav.device") }}</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.device" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </a>
                                </div>

                                <div class="text-center">
                                    <a class="btn-link link-step5" role="button" @click="navigationController('Equipments')" :class="navigation.sides.Equipments.classes">
                                        <svg class="icon icon-xl rounded" :class="navigation.sides.Equipments.iconClasses">
                                            <title>{{ airDistribution ? __("lang.kwl.nav.equipment") : __("lang.kwl.articles.own_article") }}</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.airdivision" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </a>
                                </div>

                                <div class="text-center">
                                    <a class="btn-link link-step6" role="button" @click="navigationController('Overview')" :class="navigation.sides.Overview.classes">
                                        <svg class="icon icon-xl rounded" :class="navigation.sides.Overview.iconClasses">
                                            <title>{{ __("lang.kwl.nav.material_overview") }}</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#kwleasyplan.nav.result" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </a>
                                </div>
                            </div>

                            <div class="d-flex w-full justify-content-center align-items-center py-3 px-lg-10">
                                <div class="flex-grow w-100">
                                    <p class="mb-0">
                                        <a class="btn-link hover-white link-step1" role="button" @click="navigationController('previous')" v-if="navigation.index > 0">
                                            <svg class="icon icon-xs ml-2" aria-hidden="true" v-if="navigation.index > 0">
                                                <use xlink:href="/assets/img/icon-sprite.svg#global.previous" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg>
                                            {{ __("lang.kwl.nav.previous_step") }}
                                        </a>
                                    </p>
                                </div>
                                <div class="flex-grow w-100">
                                    <p class="text-right mb-0">
                                        <a v-if="!navigation.nextClasses.includes('disabled')" class="btn-link hover-white next-step link-step2" role="button" @click="navigationController('next')" :class="navigation.nextClasses">
                                            {{ __("lang.kwl.nav.next_step") }}
                                            <svg class="icon icon-xs ml-2" aria-hidden="true">
                                                <use xlink:href="/assets/img/icon-sprite.svg#global.next" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-12 text-center">
                                <h2 class="font-weight-thin text-white mb-0 mt-2" v-if="navigation.sides.Building.show == true">1. {{ __("lang.kwl.nav.building_data") }}</h2>
                                <h2 class="font-weight-thin text-white mb-0 mt-2" v-if="navigation.sides.Rooms.show == true">2. {{ __("lang.kwl.nav.room_data") }}</h2>
                                <h2 class="font-weight-thin text-white mb-0 mt-2" v-if="navigation.sides.AirVolumes.show == true">3. {{ __("lang.kwl.nav.air_volumes") }}</h2>
                                <h2 class="font-weight-thin text-white mb-0 mt-2" v-if="navigation.sides.Devices.show == true">4. {{ __("lang.kwl.nav.device") }}</h2>
                                <h2 class="font-weight-thin text-white mb-0 mt-2" v-if="navigation.sides.Equipments.show == true">5. {{ airDistribution ? __("lang.kwl.nav.equipment") : __("lang.kwl.articles.own_article") }}</h2>
                                <h2 class="font-weight-thin text-white mb-0 mt-2" v-if="navigation.sides.Overview.show == true">6. {{ __("lang.kwl.nav.material_overview") }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Navigation -->
    </div>
</template>

<script>
import JumbotronContainer from "./JumbotronContainerComponent";
import Alert from "./AlertComponent";
import Unit from "../../models/building/Unit";

import pageValidation from "@services/validations/pageValidation";
import log from "@services/logger/index";

export default {
    components: {
        JumbotronContainer,
        Alert,
    },
    data() {
        return {
            tiny: false,
        };
    },
    methods: {
        navigationController(key) {
            switch (key) {
                case "next":
                    this.$store.dispatch("navigation/next");
                    break;
                case "previous":
                    this.$store.dispatch("navigation/previous");
                    break;
                default:
                    this.$store.dispatch("navigation/setSide", key);
                    break;
            }
        },
        handleScroll(event) {
            var header = document.getElementById("icon-pagination").offsetTop;
            var headerHight = document.getElementById("icon-pagination").offsetHeight / 2;
            var tiny_header = document.getElementById("icon-pagination-tiny").offsetTop;

            if ((window.pageYOffset - headerHight < header && header != 0) || (tiny_header != 0 && this.header_position >= window.pageYOffset + headerHight)) {
                this.tiny = false;
                if (header != 0) this.header_position = header;
            } else {
                this.tiny = true;
            }
        },
    },
    mounted() {
        pageValidation.validatePossiblePages();
        //this.navigationController('Building');

        //alert(this.$root.ready);
    },
    created() {
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    computed: {
        navigation: {
            get() {
                return this.$store.state.navigation.value;
            },
            set(value) {
                this.$store.commit("navigation/updatenavigation", value);
            },
        },
        airDistribution () {
          const units = Unit.query().get();
          return !!units.some(unit => unit.ventilationMeasure == 3 || unit.ventilationMeasure == 4);
        }
    },
    watch: {
        navigation: {
            deep: true,
            handler() {
                if (this.navigation.updated == true) {
                    pageValidation.validatePossiblePages();
                    this.navigation.updated = false;
                }
            },
        },
    },
};
</script>
